import Poppy from 'poppy';

const selectors = {
  tooltip: 'data-tooltip',
};

let sections = {};

class Tooltip {
  constructor(el) {
    this.tooltip = el;
    this.label = this.tooltip.getAttribute(selectors.tooltip);
    this.pop = null;
    this.init();
  }

  init() {
    this.pop = new Poppy({
      target: this.tooltip,
      popover: `
        <div class="poppy__tooltip__wrapper">
          <div class="poppy__tooltip">
            ${this.label}
          </div>
        </div>
      `,
      position: 'top',
      transitionSpeed: 200,
    });
    this.tooltip.addEventListener('mouseenter', this.pop.pin);
    this.tooltip.addEventListener('mouseleave', this.pop.unpin);
  }

  unload() {
    this.tooltip.removeEventListener('mouseenter', this.pop.pin);
    this.tooltip.removeEventListener('mouseleave', this.pop.unpin);
  }
}

export const tooltipSection = {
  onLoad() {
    sections[this.id] = [];
    const els = this.container.querySelectorAll(`[${selectors.tooltip}]`);
    els.forEach((el) => {
      sections[this.id].push(new Tooltip(el));
    });
  },
  onUnload: function () {
    sections[this.id].forEach((el) => {
      if (typeof el.unload === 'function') {
        el.unload();
      }
    });
  },
};
